/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../../../app/modules/auth";
import { KTIcon, toAbsoluteUrl } from "../../../helpers";
import { Modal, ModalBody, ModalFooter } from "react-bootstrap";
import clsx from "clsx";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import { RootState } from "../../../../global/store";
import request from "../../../../utils/request";

const HeaderUserMenu: FC = () => {
  const { currentUser, logout } = useAuth();
  const name = localStorage.getItem('name')
  const userEmail = localStorage.getItem('email')
  const customerNumbers = localStorage.getItem("customerNumbers")
  const customerNumber = localStorage.getItem('customerNum');

  const dataCapel = useSelector((v: RootState) => v.customerReducer.identify)
  const navigate = useNavigate();
  const [modalSwitchAccount, setmodalSwitchAccount] = useState(false);
  const [modalAddAccount, setmodalAddAccount] = useState(false);
  const [capelData, setCapelData] = useState<any>(null);
  const [custNum, setcustNum] = useState(customerNumber || '');
  const [capelId, setcapelId] = useState('')
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);

  const getAllAccounts = async (capelData) => {
    setLoading(true)
    await request.post('/users/GetAllAccount', capelData).then((v) => {
      setAccounts(v.data)
      setLoading(false)
    });
  }

  useEffect(() => {
    if (customerNumbers) {
      setCapelData(JSON.parse(customerNumbers))
    }
  }, [customerNumbers]);

  // Logic determine user type based on IDs
  const activeCustNum = customerNumber || dataCapel?.cust_number || '';
  const hasCustomerNumber = activeCustNum && activeCustNum !== '' && activeCustNum !== 'null';
  
  let mappedCompanyName = '';
  if (hasCustomerNumber && customerNumbers) {
    try {
      const accounts = JSON.parse(customerNumbers);
      const activeAccount = Array.isArray(accounts)
        ? accounts.find((v: any) => v?.custNumber === activeCustNum)
        : null;
      mappedCompanyName = activeAccount?.namaPerusahaan || '';
    } catch {
      mappedCompanyName = '';
    }
  }

  const companyNameDisplay = dataCapel?.cust_name_decrypt || mappedCompanyName || name || userEmail || '';

  return (
    <div
      className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-300px"
      data-kt-menu="true"
    >
      <div className="menu-item px-3">
        <div className="menu-content d-flex align-items-center px-3">
          <div className="d-flex flex-column">
            <div className="fs-5 text-overflow-one fw-bolder">
              {companyNameDisplay}
            </div>
            {hasCustomerNumber && (
              <div className="fw-normal fs-6">
                {activeCustNum}
              </div>
            )}
            <div className="fw-semibold text-muted fs-7">
              {userEmail}
            </div>
          </div>
        </div>
      </div>

      <div className="separator my-2"></div>

      {/* <Languages /> */}

      <div className="menu-item px-5 my-1">
        {
          // JSON.parse(localStorage.getItem('pelanggan') || 'false') &&
          <Link to="/setting" className="menu-link px-5 d-flex justify-content-between">
            My profile
            <div style={{ maxWidth: '140px' }} className="text-overflow-one fw-normal">{localStorage?.getItem('email')}</div>
          </Link>
        }
      </div>
      {/* <div className="menu-item px-5 my-1">
        <Link to="/auth/forgot-password" className="menu-link px-5">
          Change password
        </Link>
      </div> */}

      {(capelData && capelData?.length > 1 && capelData[0]?.custNumber !== '') && (
        <div className="menu-item px-5 my-1">
          <div
            onClick={async () => {
              setmodalSwitchAccount(true)
              await getAllAccounts(capelData)
            }}
            className="menu-link px-5"
          >
            Switch account
          </div>
        </div>
      )}

      <Modal
        show={modalSwitchAccount}
        centered
        onHide={() => setmodalSwitchAccount(false)}
        dialogClassName="modal-md"
      >
        <div className='modal-header'>
          <h5 className='modal-title'>Switch Account</h5>
          <div
            onClick={() => { setmodalSwitchAccount(false) }}
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
          >
            <KTIcon iconName='cross' className='fs-2x' />
          </div>
        </div>
        <ModalBody>
          <div data-kt-buttons="true">
            {
              !loading
                ? accounts.map((v: any, id) => {
                  console.info(v.custNumber, custNum)
                  return (
                    <label key={id} className="btn btn-active-light-primary d-flex flex-stack text-start p-2 mb-5">
                      <div className="d-flex align-items-center me-2">
                        <div className="flex-grow-1">
                          <div className="symbol symbol-45px me-5">
                            <img
                              src={toAbsoluteUrl("/media/avatars/blank.png")}
                              alt=""
                            />
                          </div>
                        </div>
                        <div>
                          <span className="text-overflow-one">{v.namaPerusahaan}</span>
                          <div className="text-muted fs-8">{v.custNumber}</div>
                        </div>
                      </div>
                      <div className="form-check form-check-custom form-check-solid form-check-primary ">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="plan"
                          checked={v.custNumber == custNum ? true : false}
                          value="startup"
                          onChange={() => {
                            setcapelId(v.capelID)
                            setcustNum(v.custNumber)
                          }}
                        />
                      </div>
                    </label>
                  )
                })
                : <span
                  className="indicator-progress text-center"
                  style={{ display: 'block' }}
                >
                  Please wait...{' '}
                  <span className="spinner-border spinner-border-sm align-middle"></span>
                </span>
            }
          </div>
        </ModalBody>
        <ModalFooter className="d-flex flex-wrap justify-content-center">
          <button
            type="button"
            id="kt_sign_in_submit"
            className="btn btn-primary w-100"
            onClick={() => {
              localStorage.setItem('capelId', capelId)
              localStorage.setItem('customerNum', custNum!)
              window.location.reload()
            }}
          >
            Switch account
          </button>
          {/* <div className="btn text-gray-500 text-center fw-semibold fs-6text-center">
            <div
              className="link-primary"
              onClick={() => {
                setmodalAddAccount(true);
                setmodalSwitchAccount(false);
              }}
            >
              Add new account
            </div>
          </div> */}
        </ModalFooter>
      </Modal>

      <Modal
        show={modalAddAccount}
        centered
        onHide={() => setmodalAddAccount(false)}
      >
        <div className='modal-header'>
          <h5 className='modal-title'>Add account</h5>
          <div
            onClick={() => { setmodalAddAccount(false) }}
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
          >
            <KTIcon iconName='cross' className='fs-2x' />
          </div>
        </div>
        <form
          className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
          // onSubmit={formik.handleSubmit}
          noValidate
          id="kt_login_signin_form"
          autoComplete="off"
        >
          <ModalBody>
            <div className="fv-row mb-8">
              <label className="form-label fs-6 fw-bolder text-dark">
                ID Customer
              </label>
              <input
                placeholder="Fill with ID customer"
                // {...formik.getFieldProps("email")}
                className={clsx(
                  "form-control bg-transparent"
                  // { "is-invalid": formik.touched.email && formik.errors.email },
                  // {
                  //   "is-valid": formik.touched.email && !formik.errors.email,
                  // }
                )}
                type="text"
                name="text"
                autoComplete="off"
              />
              {/* {formik.touched.email && formik.errors.email && (
          <div className="fv-plugins-message-container">
            <span role="alert">{formik.errors.email}</span>
          </div>
        )} */}
            </div>
            <div className="fv-row mb-3">
              <label className="form-label fw-bolder text-dark fs-6 mb-0">
                Password
              </label>
              <input
                type="password"
                autoComplete="off"
                placeholder="Fill password"
                // {...formik.getFieldProps("password")}
                className={clsx(
                  "form-control bg-transparent"
                  // {
                  //   "is-invalid": formik.touched.password && formik.errors.password,
                  // },
                  // {
                  //   "is-valid": formik.touched.password && !formik.errors.password,
                  // }
                )}
              />
              {/* {formik.touched.password && formik.errors.password && (
          <div className="fv-plugins-message-container">
            <div className="fv-help-block">
              <span role="alert">{formik.errors.password}</span>
            </div>
          </div>
        )} */}
            </div>

            <div className="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold">
              <div />
              <Link to="/auth/forgot-password" className="link-primary">
                Forgot password?
              </Link>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="submit"
              id="kt_sign_in_submit"
              className="btn btn-primary w-100"
            >
              Login
            </button>
          </ModalFooter>
        </form>
      </Modal>

      <div className="separator my-2"></div>

      <div className="menu-item px-5">
        <a
          onClick={() => {
            Cookies.remove("token");
            localStorage.removeItem("userId")
            localStorage.removeItem("capelId")
            localStorage.removeItem("customerNumbers")
            localStorage.removeItem("customerNum")
            localStorage.removeItem("pelanggan")
            localStorage.removeItem("login")
            setTimeout(() => {
              window.location.replace('/auth')
            }, 500);
          }}
          className="menu-link px-5"
        >
          Sign out
        </a>
      </div>
    </div>
  );
};

export { HeaderUserMenu };
